import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { SalesCode } from "@/app/services/generated/salescodeService";
import { salesCodeService } from "@/app/services/generated/salescodeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasSalesCodesCache {
  salesCodes: SalesCodesCache;
}

// Singleton cache store
const salesCodesCacheStore = new EntityCacheStore<SalesCode>(
  EnumCacheEntityType.salesCode,
  async () => salesCodeService.getAllSalesCodes()
);

// Ephemeral reader
export default class SalesCodesCache extends EntityWithGuidKeyCache<SalesCode> {
  constructor() {
    super(salesCodesCacheStore, (x) => x.id);
  }
}
